import {ColumType} from '@/components/types';
import moment from 'moment';

type DummyDataType = {
  status: ColumType;
  deadline: string;
};

export const dummyStatus = new Map<string, DummyDataType>([
  ['1', {status: 'doing', deadline: '2020-01-15'}],
  ['2', {status: 'done', deadline: '2020-02-15'}],
  ['3', {status: 'doing', deadline: '2020-03-15'}],
  ['4', {status: 'expired', deadline: '2020-04-15'}],
  ['5', {status: 'done', deadline: '2020-05-15'}],
  ['6', {status: 'no-deadline', deadline: ''}],
  ['7', {status: 'done', deadline: '2020-07-15'}],
  ['8', {status: 'doing', deadline: '2020-08-15'}],
  ['9', {status: 'doing', deadline: '2020-09-15'}],
  ['10', {status: 'doing', deadline: '2020-10-15'}],
  ['11', {status: 'doing', deadline: '2020-11-15'}],
  ['12', {status: 'doing', deadline: '2020-12-15'}],
]);

export const getStatus = (
  deadlinest: string,
  total: number,
  done: number,
  main: boolean
): ColumType => {
  if (total == done) {
    return 'done';
  }
  if (!main) {
    return 'doing';
  }

  const deadline = moment(deadlinest);
  if (!deadline.isValid()) {
    return 'no-deadline';
  }

  if (deadline.isAfter(moment())) {
    return 'doing';
  } else {
    return 'expired';
  }
};
